import axios from "../../utils/axios";
import { toast } from "react-hot-toast";

// Create Store
export const CreateStore = async (req) => {
    try {

        const { data } = await axios.post('/vendor/store', req, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        throw error;
    }
};
// Edit Store

export const EditStore = async (req, id) => {
    try {

        const { data } = await axios.post(`/vendor/store/${id}`, req, { 
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        throw error;
    }
};

// Create Store
export const deleteImagesStore = async (req) => {
    try {

        const { data } = await axios.post('/vendor/store/images/delete', req, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            },
        });
        if (data.status !== false) {
            toast.success(data?.message || "تمت العملية بنجاح");
        } else {
            toast.error(data?.message || "هناك خطأ ما ");
        }
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        const errorMessage = error.response?.data?.message || "حدث خطأ ما";
        toast.error(errorMessage);
        throw error;
    }
};

// Get Store
export const getStore = async (storeId) => {
    const { data } = await axios.get(`/vendor/store?id=${storeId}`);
    return data;
};

